import { render, staticRenderFns } from "./RejectPayment.vue?vue&type=template&id=17a6603c&scoped=true"
import script from "./RejectPayment.vue?vue&type=script&lang=js"
export * from "./RejectPayment.vue?vue&type=script&lang=js"
import style0 from "./RejectPayment.vue?vue&type=style&index=0&id=17a6603c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a6603c",
  null
  
)

export default component.exports